export var ETextType;
(function (ETextType) {
    ETextType["email"] = "email";
    ETextType["tel"] = "tel";
})(ETextType || (ETextType = {}));
